window.global ||= window

import * as Sentry from '@sentry/browser'

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  const { worker } = await import('./mocks/browser')

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}

await enableMocking()

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://1b491326b6c94e999c0c0064b88d9545@sentry.io/2272841',
    environment: import.meta.env.VITE_REACT_APP_ENV,
  })
}

export {}
